// extracted by mini-css-extract-plugin
module.exports = {"post-fetch-link":"post-fetch-link_post-fetch-link__CRLqc","button-link":"post-fetch-link_button-link__CHPWF"};